<template>
    <div>
        <ValidationObserver ref="observer" tag="div">
            <form @submit.prevent="onContinuar" novalidate>
                <section
                    class="tw:mb-8"
                    :class="deshabilitado ? 'tw:opacity-60 tw:pointer-events-none' : ''"
                >
                    <div class="row tw:gap-y-4">
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="compradorLocal.name"
                                rules="required"
                                :label="t('formularios.nombre')"
                                :name="t('formularios.nombre')"
                                :disabled="deshabilitado"
                            />
                        </div>
                        <div
                            v-if="compradorLocal.identification.type !== 'NIF'"
                            class="col-12 col-lg-6"
                        >
                            <FormInput
                                v-model="compradorLocal.lastName"
                                rules="required"
                                :label="t('formularios.apellidos')"
                                :name="t('formularios.apellidos')"
                                :disabled="deshabilitado"
                            />
                        </div>
                        <div
                            v-if="compradorLocal.identification.type !== 'NIF'"
                            class="col-12 col-lg-6"
                        >
                            <div class="form-group">
                                <label>{{ t('formularios.genero') }}</label>
                                <multiselect
                                    v-model="generoSeleccionado"
                                    :options="generos"
                                    label="name"
                                    track-by="id"
                                    class="custom-multiselect"
                                    :disabled="deshabilitado"
                                    :placeholder="t('formularios.genero')"
                                />
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <DocumentoTipo
                                :value="compradorLocal.identification.type"
                                :disabled="deshabilitado"
                                @input="onTipoDocumentoChange"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <DocumentoValor
                                :type="compradorLocal.identification.type"
                                :value="compradorLocal.identification.value"
                                :disabled="deshabilitado"
                                :required="true"
                                @input="onDocumentoValorChange"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form-group">
                                <label>{{ t('formularios.telefono') }}</label>
                                <PhoneInput
                                    :phone="compradorLocal.phone"
                                    :desactivar="deshabilitado"
                                    :required="false"
                                    @setNumber="setPhoneNumber"
                                />
                            </div>
                        </div>
                        <div
                            v-if="compradorLocal.identification.type !== 'NIF'"
                            class="col-12 col-lg-6"
                        >
                            <FormInput
                                v-model="compradorLocal.birthdate"
                                rules="required"
                                type="date"
                                :label="t('formularios.nacimiento')"
                                :name="t('formularios.nacimiento')"
                                :disabled="deshabilitado"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="compradorLocal.email"
                                vid="email-confirm-datos-simp"
                                rules="required|email"
                                :label="t('formularios.email')"
                                :name="t('formularios.email')"
                                :disabled="deshabilitado"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="compradorLocal.email_confirm"
                                :rules="'required|email|confirmed_ci:@email-confirm-datos-simp'"
                                :label="t('formularios.confirmar_email')"
                                :name="t('formularios.confirmar_email')"
                                :disabled="deshabilitado"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <Paises
                                :pais="paisSeleccionado"
                                :desactivar="deshabilitado"
                                @selected="onPaisSeleccionado"
                                @rellenarPais="onPaisLoaded"
                            />
                        </div>
                        <template v-if="tieneProvincias">
                            <div class="col-12 col-lg-6">
                                <Provincias
                                    :pais="paisSeleccionado?.id || 0"
                                    :desactivar="deshabilitado"
                                    @selected="onProvinciaSeleccionada"
                                    @provinciasCargadas="onProvinciasLoaded"
                                />
                            </div>
                            <div class="col-12 col-lg-6">
                                <Locations
                                    :provincia="provinciaSeleccionada"
                                    :desactivar="deshabilitado || !provinciaSeleccionada"
                                    @selected="onLocalidadSeleccionada"
                                />
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12 col-lg-6">
                                <FormInput
                                    v-model="compradorLocal.address.state"
                                    :label="t('formularios.provincia')"
                                    :name="t('formularios.provincia')"
                                    :disabled="deshabilitado"
                                />
                            </div>
                            <div class="col-12 col-lg-6">
                                <FormInput
                                    v-model="compradorLocal.address.city"
                                    :label="t('formularios.localidad')"
                                    :name="t('formularios.localidad')"
                                    :disabled="deshabilitado"
                                />
                            </div>
                        </template>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="compradorLocal.cp"
                                rules="required"
                                :label="t('formularios.cp')"
                                :name="t('formularios.cp')"
                                :disabled="deshabilitado"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="compradorLocal.address.streetLine1"
                                :label="t('formularios.domicilio')"
                                :name="t('formularios.domicilio')"
                                :disabled="deshabilitado"
                            />
                        </div>
                    </div>
                </section>

                <section v-if="!props.deshabilitado" class="tw:mb-8">
                    <h2 class="tw:text-lg tw:font-semibold tw:mb-4">
                        {{ t('formularios.tipo_abono', { abono: textoSimpatizante }) }}
                    </h2>

                    <Skeleton
                        v-if="loading && precios.length === 0"
                        padding="tw:p-4"
                        class="tw:w-full"
                    >
                        <template #skeleton>
                            <SkeletonItem class="tw:h-16 tw:w-full tw:mb-2 tw:rounded-md" />
                            <SkeletonItem class="tw:h-16 tw:w-full tw:mb-2 tw:rounded-md" />
                        </template>
                    </Skeleton>

                    <div
                        v-else-if="error && precios.length === 0"
                        class="tw:bg-red-50 tw:border tw:border-red-200 tw:rounded-md tw:p-4 tw:text-red-700 tw:whitespace-pre-line"
                    >
                        {{ error }}
                    </div>

                    <div
                        v-else-if="precios.length === 0"
                        class="tw:bg-gray-50 tw:border tw:border-gray-200 tw:rounded-md tw:p-4 tw:text-center tw:text-gray-600"
                    >
                        {{ t('formularios.no_disponible') }}
                    </div>

                    <template v-else>
                        <div
                            v-if="error"
                            class="tw:bg-red-50 tw:border tw:border-red-200 tw:rounded-md tw:p-4 tw:text-red-700 tw:mb-2 tw:whitespace-pre-line"
                        >
                            {{ error }}
                        </div>
                        <button
                            v-for="precio in preciosDisponibles"
                            :key="precio.id"
                            type="button"
                            :disabled="deshabilitado"
                            :aria-pressed="precioSeleccionadoLocal === precio.salesCategoryId"
                            class="tw:w-full tw:text-left tw:p-4 tw:mb-2 tw:rounded-md tw:border-2 tw:transition tw:duration-150"
                            :class="precioSeleccionadoLocal === precio.salesCategoryId
                                ? 'tw:border-blue-600 tw:bg-blue-50 tw:ring-2 tw:ring-blue-200'
                                : (deshabilitado
                                    ? 'tw:border-gray-200 tw:bg-gray-50 tw:opacity-50 tw:cursor-not-allowed'
                                    : 'tw:border-gray-300 tw:bg-white tw:hover:border-blue-400 tw:hover:bg-blue-50 tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-blue-200')"
                            @click="seleccionarPrecio(precio.salesCategoryId)"
                        >
                            <div class="tw:flex tw:justify-between tw:items-center">
                                <span class="tw:font-medium">{{ precio.salesCategoryName }}</span>
                                <span class="tw:font-semibold tw:text-blue-700">{{ formatPrice(precio.amount) }}</span>
                            </div>
                        </button>

                        <div
                            v-for="precio in preciosCerrados"
                            :key="precio.id"
                            class="tw:w-full tw:text-left tw:p-4 tw:mb-2 tw:rounded-md tw:bg-gray-50 tw:border tw:border-gray-200 tw:opacity-60 tw:cursor-not-allowed"
                            :title="t('general.venta_cerrada')"
                        >
                            <div class="tw:flex tw:justify-between tw:items-center">
                                <span>{{ precio.salesCategoryName }}</span>
                                <span class="tw:font-semibold tw:text-gray-500 tw:line-through">{{ formatPrice(precio.amount) }}</span>
                            </div>
                        </div>
                    </template>
                </section>

                <div v-if="!props.deshabilitado" class="tw:flex tw:justify-end tw:gap-2 tw:mb-6">
                    <Button
                        id="datos-simp-continuar"
                        data-cy="datos-simp-continuar"
                        type="submit"
                        :label="t('formularios.continuar')"
                        :disabled="loading || !precioSeleccionadoLocal"
                    />
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script setup>
    import { ref, computed, watch, onMounted } from 'vue';
    import store from '@/store';
    import { ValidationObserver } from 'vee-validate';
    import FormInput from '@/components/common/FormInput.vue';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';
    import Paises from '@/components/common/forms/Paises.vue';
    import Provincias from '@/components/common/forms/Provincias.vue';
    import Locations from '@/components/common/forms/Locations.vue';
    import Button from '@/modules/ui/Button.vue';
    import { Skeleton, SkeletonItem } from '@/modules/front/ui/skeleton';
    import { t } from '@/utils/i18n-helper';

    const props = defineProps({
        precios: {
            type: Array,
            default: () => []
        },
        preciosDisponibles: {
            type: Array,
            default: () => []
        },
        preciosCerrados: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: null
        },
        deshabilitado: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['continuar', 'cancelar']);

    const teatro = computed(() => store.getters.getTeatro || {});
    const textoSimpatizante = computed(() => teatro.value.texto_simpatizante || '');
    const generos = computed(() => store.getters.getGeneros || []);

    const compradorLocal = ref({
        name: '',
        lastName: '',
        gender: '',
        email: '',
        email_confirm: '',
        phone: '',
        birthdate: '',
        identification: { type: 'DNI', value: '', issuerCode: 'ES' },
        address: {
            country: '',
            state: '',
            city: '',
            streetLine1: ''
        },
        cp: '',
        hasNotOwnIdentification: false,
        isMinor: false
    });

    const paisSeleccionado = ref(null);
    const provinciaSeleccionada = ref(null);
    const tieneProvincias = ref(true);
    const generoSeleccionado = ref(null);
    const precioSeleccionadoLocal = ref(null);
    const observer = ref(null);

    const generoMap = { Hombre: 'MALE', Mujer: 'FEMALE' };
    const generoMapReverse = { MALE: 'Hombre', FEMALE: 'Mujer' };

    watch(generoSeleccionado, val => {
        compradorLocal.value.gender = val ? (generoMap[val.name] || 'OTHER') : '';
    });
    watch(() => compradorLocal.value.gender, val => {
        if (val) {
            const name = generoMapReverse[val];
            const match = name ? generos.value.find(g => g.name === name) : null;
            generoSeleccionado.value = match || null;
        } else {
            generoSeleccionado.value = null;
        }
    });

    function formatPrice(amount) {
        return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amount || 0);
    }

    function seleccionarPrecio(id) {
        if (props.deshabilitado) return;
        precioSeleccionadoLocal.value = id;
    }

    function onTipoDocumentoChange(tipo) {
        compradorLocal.value.identification.type = tipo;
    }

    function onDocumentoValorChange(val) {
        compradorLocal.value.identification.value = val;
    }

    function setPhoneNumber(number) {
        compradorLocal.value.phone = number == null ? '' : String(number);
    }

    function onPaisSeleccionado(opt) {
        paisSeleccionado.value = opt;
        compradorLocal.value.address.country = opt?.iso3 || '';
        provinciaSeleccionada.value = null;
        compradorLocal.value.address.state = '';
        compradorLocal.value.address.city = '';
        tieneProvincias.value = true;
    }

    function onPaisLoaded(p) {
        if (!p) return;
        // El país por defecto (España) llega por el evento de carga inicial
        // (@rellenarPais): misma ruta que onPaisSeleccionado para que la UI y
        // el comprador enviado nunca diverjan (address.country incluido).
        onPaisSeleccionado(p);
    }

    function onProvinciaSeleccionada(opt) {
        provinciaSeleccionada.value = opt;
        compradorLocal.value.address.state = opt?.nombre || '';
    }

    function onProvinciasLoaded(list) {
        tieneProvincias.value = Array.isArray(list) && list.length > 0;
        if (!tieneProvincias.value) {
            provinciaSeleccionada.value = null;
            compradorLocal.value.address.state = '';
            compradorLocal.value.address.city = '';
            return;
        }
        if (compradorLocal.value.address.state && !provinciaSeleccionada.value) {
            const match = list.find(p => p.nombre === compradorLocal.value.address.state);
            if (match) provinciaSeleccionada.value = match;
        }
    }

    function onLocalidadSeleccionada(opt) {
        compradorLocal.value.address.city = opt?.nombre || '';
    }

    function onContinuar() {
        if (props.deshabilitado) return;
        if (!precioSeleccionadoLocal.value) return;
        const datos = { ...compradorLocal.value };
        // Los campos ocultos para NIF no deben enviarse a backend.
        if (datos.identification.type === 'NIF') {
            datos.lastName = '';
            datos.gender = '';
            datos.birthdate = '';
        }
        if (observer.value) {
            observer.value.validate().then(valid => {
                if (!valid) return;
                emit('continuar', datos, precioSeleccionadoLocal.value);
            });
            return;
        }
        emit('continuar', datos, precioSeleccionadoLocal.value);
    }

    function onCancelar() {
        emit('cancelar');
    }

    onMounted(() => {
        if (props.preciosDisponibles.length === 1) {
            precioSeleccionadoLocal.value = props.preciosDisponibles[0].salesCategoryId;
        }
    });

    watch(() => props.preciosDisponibles, nuevo => {
        if (precioSeleccionadoLocal.value && !nuevo.find(p => p.salesCategoryId === precioSeleccionadoLocal.value)) {
            precioSeleccionadoLocal.value = null;
        }
    });

    // Expuesto para tests: permite verificar el payload de comprador sin
    // depender del observer de validación.
    defineExpose({
        compradorLocal,
        paisSeleccionado,
        onPaisLoaded,
        onContinuar
    });
</script>
